import React, {useEffect, useRef, useState} from 'react';
import {IconClose} from '@arco-design/web-react/icon';

const SAVED_STREAM_KEY = 'hk-last-live-stream';
const PREVIEW_STREAM = {id: 'iR3WNBy7eRQ', title: '六合彩109 2026年10月13日｜ 六合視頻廣播'};
const validStream = data => /^[\w-]{11}$/.test(data?.id || '') && typeof data?.title === 'string';
function savedStream() {
  try {
    const saved = JSON.parse(localStorage.getItem(SAVED_STREAM_KEY));
    if (validStream(saved)) return saved;
  } catch {}
  return PREVIEW_STREAM;
}

export function HongKongLiveDialog({onClose}) {
  const dialog = useRef(null);
  const [reload, setReload] = useState(0);
  const [stream, setStream] = useState(savedStream);
  const [notice, setNotice] = useState('正在查询最新场次，先显示已保存场次。');
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current.showModal();
    return () => { document.body.style.overflow = overflow; previous?.focus(); };
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    setNotice('正在查询最新场次，先显示已保存场次。');
    async function load() {
      try {
        const response = await fetch('/api/live/hk', {signal: controller.signal});
        if (!response.ok) throw new Error();
        const data = await response.json();
        if (!validStream(data)) throw new Error();
        if (!controller.signal.aborted) {
          setStream(data); setNotice('');
          try { localStorage.setItem(SAVED_STREAM_KEY, JSON.stringify(data)); } catch {}
        }
      } catch {
        if (!controller.signal.aborted) setNotice('');
      }
    }
    load();
    return () => controller.abort();
  }, [reload]);
  return <dialog ref={dialog} className="peek-dialog macau-live-dialog" aria-labelledby="hk-live-title" onCancel={event => {event.preventDefault(); onClose();}}>
    <div className="section-heading"><h2 id="hk-live-title">香港六合彩 · 直播</h2><button type="button" aria-label="关闭直播" onClick={onClose}><IconClose/></button></div>
    <><p className="hk-live-title">{stream.title}</p><iframe key={`${stream.id}:${reload}`} className="hk-live-frame" src={`https://www.youtube.com/embed/${stream.id}?playsinline=1&rel=0&hl=zh-TW`} title="香港六合彩直播播放器" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen referrerPolicy="strict-origin-when-cross-origin"/></>
    {notice && <p className="muted" role="status">{notice}</p>}
    <div className="macau-live-footer" style={{justifyContent: 'flex-end'}}><button type="button" onClick={() => setReload(value => value + 1)}>重新加载</button></div>
  </dialog>;
}
